import { createSlice } from '@reduxjs/toolkit'
import { TeamPlayerClaims } from '../sdk/model'

const initialState : Record<string, TeamPlayerClaims[]> = {};

const playerClaimDataLoadSlice = createSlice({
  name: 'playerClaimDataLoad',
  initialState,
  reducers: {
    setPlayerClaimDataLoad (state, action) {
      return state = action.payload
    }
  }
})

export const { setPlayerClaimDataLoad } = playerClaimDataLoadSlice.actions
export default playerClaimDataLoadSlice.reducer